import { render, staticRenderFns } from "./MediaResult.vue?vue&type=template&id=840552ac&scoped=true&"
import script from "./MediaResult.vue?vue&type=script&lang=js&"
export * from "./MediaResult.vue?vue&type=script&lang=js&"
import style0 from "./MediaResult.vue?vue&type=style&index=0&id=840552ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840552ac",
  null
  
)

export default component.exports